import { RegistrationDetailsFormDataCustomer } from './RegistrationDetailsFormDataCustomer';
import { RegistrationDetailsFormDataCloudAccount } from './RegistrationDetailsFormDataCloudAccount';
import { RegistrationDetailsFormDataNewCloudAccount } from './RegistrationDetailsFormDataNewCloudAccount';

export class RegistrationDetailsFormData {
    customer: RegistrationDetailsFormDataCustomer = new RegistrationDetailsFormDataCustomer();
    cloudAccount: RegistrationDetailsFormDataCloudAccount = new RegistrationDetailsFormDataCloudAccount();
    newCloudAccount: RegistrationDetailsFormDataNewCloudAccount = new RegistrationDetailsFormDataNewCloudAccount();
}
